// extracted by mini-css-extract-plugin
module.exports = {"types-of-green-card":"TypesOfGreenCard_types-of-green-card__99Qb8"};